import ShowDetails from "./components/kyc-admin/show.vue";
import LandingPage from "./components/kyc-admin/index.vue";
import LandingPageCKyc from "./components/ckyc-admin/index.vue";
import ShowDetailsCkyc from "./components/ckyc-admin/show.vue"
import LandingPageVideo from "./components/video-admin/index.vue";
import ShowDetailsVideo from "./components/video-admin/show.vue"
import Login from "./components/Login.vue";
import Template from "./components/template.vue";
import KycData from "./components/Kyc-data.vue";
import RotateImage from "./commons/RotateImage/RotateImage.vue";
import MaskImage from "./commons/MaskImage/MaskImage.vue"
import RotateImageCkyc from "./commons/RotateImage/RotateImageCkyc.vue";
import MaskImageCkyc from "./commons/MaskImage/MaskImageCkyc.vue"
import AdminPartner from "./components/admin-partner.vue";
import LandingPageSignature from "./components/signature-admin/index.vue";
import ShowSignatureDetails from "./components/signature-admin/show.vue"

const routes = [
  {
    path: "/",
    component: Template,
    name: "home",
    meta: {
      title: "KYC Verification"
    },
    children: [
      { path: "", name: "kyc-login", component: Login },
      {
        path: "/dashboard",
        name: "dashboard",
        component: KycData,
        meta: { auth: true },
        children: [
          {
            path: "/dashboard/admin",
            name: "admin",
            component: AdminPartner,
            children: [
              {
                path: "/:partner/mask/:id/:imgname",
                name: "kyc-details-mask-img",
                component: MaskImage
              },
              {
                path: "/:partner/kyc-details-id/:id/:imgname",
                name: "kyc-details-edit-img",
                component: RotateImage
              },
              {
                path: "/:partner/kyc-details-id/:id",
                name: "kyc-details-id",
                component: ShowDetails
              },
              {
                path: "/:partner/kyc-details/:status",
                name: "kyc-details",
                component: LandingPage,
              },
              {
                path: "/:partner/ckyc-details/:status",
                name: "ckyc-details",
                component: LandingPageCKyc
              },
              {
                path: "/:partner/ckyc-details-id/:id",
                name: "ckyc-details-id",
                component: ShowDetailsCkyc
              }, 
              {
                path: "/:partner/video-details/:status",
                name: "video-details",
                component: LandingPageVideo
              },
              {
                path: "/:partner/video-details-id/:id",
                name: "video-details-id",
                component: ShowDetailsVideo
              }, 
              {
                path: "/:partner/ckyc-mask/:id/:imgname",
                name: "ckyc-details-mask-img",
                component: MaskImageCkyc
              },
              {
                path: "/:partner/ckyc-details-id/:id/:imgname",
                name: "ckyc-details-edit-img",
                component: RotateImageCkyc
              }, 
              {
                path: "/:partner/verify-signature/:status",
                name: "verify-signature",
                component: LandingPageSignature 
              },  
              {
                path: "/:partner/verify-signature-details-id/:id",
                name: "verify-signature-details",
                component: ShowSignatureDetails
              },                
            ]            
          },                  
        ]
      }
    ]
  },
  { path: "*", redirect: "/" },
  // { path: "/", name: 'admin', component: AdminPartner },
];

export default routes;
